<adapt-dialog [minWidth]="460"
              [maxWidth]="930"
              [allowResize]="true">
    <h3 adapt-dialog-title>
        @if (isTeam(entity)) {
            Change appearance for the "{{entity.name}}" {{entity.teamTypeName.toLocaleLowerCase()}}
        } @else {
            Change appearance for all {{entity.name}}s
        }
    </h3>

    <div adapt-dialog-content>
        @if (!isTeam(entity)) {
            <div class="alert alert-info">You are editing the {{entity.name}} base style.
                <b>This will affect all {{entity.name.toLocaleLowerCase()}}s that do not have a custom appearance set.</b></div>
        }

        <adapt-team-display-configuration [entity]="entity"
                                          (configureOrganisationGroupTypesClicked)="onConfigureOrganisationGroupTypesClicked()"></adapt-team-display-configuration>
    </div>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   [discardConfirmationInstance]="instance"> </adapt-standard-dialog-buttons>
</adapt-dialog>
